module.exports = __webpack_public_path__ + "media/images/signinGoogle-7d9940d6.svg";